import React from "react";
import { Chip, IconButton, Tooltip } from "@sscs/ui";
import { CopyIcon } from "@sscs/ui/icons";
import { TRANSFORM_EXPLOIT_FLAG } from "../../../constants";
import { getCvssSeverity } from "../../../utils";
import { composeCvssStory, formatCvssVector } from "./cvss";
import styles from "./vulnerabilityTooltip.module.scss";
// The tags carry the same labels as the row's own chips, but nothing here
// filters — a tooltip is not a place to click.
const ExploitTags = ({ tags, }) => (React.createElement("div", { className: styles.tags }, tags.map((tag) => (React.createElement(Chip, { key: tag, label: TRANSFORM_EXPLOIT_FLAG[tag] })))));
const TooltipContent = ({ cvss, exploit, }) => (React.createElement("div", { className: styles.body },
    (exploit === null || exploit === void 0 ? void 0 : exploit.length) ? React.createElement(ExploitTags, { tags: exploit }) : null,
    composeCvssStory(cvss).map((sentence) => (React.createElement("p", { key: sentence }, sentence)))));
const VectorFooter = ({ vector }) => (React.createElement("div", { className: styles.footer },
    React.createElement("span", { className: styles.vector }, vector),
    React.createElement(IconButton, { size: "small", "aria-label": "Copy CVSS vector", onClick: async () => {
            await navigator.clipboard.writeText(vector);
        } },
        React.createElement(CopyIcon, null))));
export const VulnerabilityTooltip = ({ cvss, exploit, children, }) => {
    const severity = getCvssSeverity(cvss.base_score);
    const vector = formatCvssVector(cvss);
    return (React.createElement(Tooltip, { trigger: "graphic", tooltipType: "card", header: React.createElement(React.Fragment, null,
            React.createElement("span", null, severity),
            React.createElement("span", null, cvss.base_score.toFixed(1))), headerClassName: styles[`band-${severity}`], title: React.createElement(TooltipContent, { cvss: cvss, exploit: exploit }), footer: vector && React.createElement(VectorFooter, { vector: vector }) },
        React.createElement("div", null, children)));
};
export default VulnerabilityTooltip;
//# sourceMappingURL=VulnerabilityTooltip.js.map